import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Optional, SkipSelf } from "@angular/core";
import { AuthConfig, OAuthModule, OAuthModuleConfig, OAuthResourceServerErrorHandler, OAuthStorage } from "angular-oauth2-oidc";
import { AuthService } from "./auth/auth.service";
import { AuthGuard } from "./auth/auth-guard.service";
import { AuthGuardWithForcedLogin } from "./auth/auth-guard-with-forced-login.service";
import { authConfig } from "./auth/auth-config";
import { authModuleConfig } from "./auth/auth-module-config";
import { authAppInitializerFactory } from "./auth/auth-app-initializer.factory";
import { OAuthServerErrorHandler } from "./auth/auth-error-handler";
import { RoleGuard } from "./auth/role-guard.service";

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
    return localStorage;
}

@NgModule({
    imports: [
        HttpClientModule,
        OAuthModule.forRoot(),
    ],
    providers: [
        AuthService,
        RoleGuard,
        AuthGuard,
        AuthGuardWithForcedLogin,
    ],
})
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: APP_INITIALIZER, useFactory: authAppInitializerFactory, deps: [AuthService], multi: true },
                { provide: AuthConfig, useValue: authConfig },
                { provide: OAuthModuleConfig, useValue: authModuleConfig },
                { provide: OAuthStorage, useFactory: storageFactory },
                { provide: OAuthResourceServerErrorHandler, useClass: OAuthServerErrorHandler },
            ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
